import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { CheckCircle2 } from "lucide-react";

const PricingPage = () => {
  const tiers = [
    { name: "Standard", price: 60, sub: "praní + složení", features: ["Praní podle preferencí", "Skládání", "Sběr a doprava"], testid: "tier-standard" },
    { name: "Premium", price: 80, sub: "praní + složení + žehlení", featured: true, features: ["Profesionální žehlení", "Vyšívané a citlivé prádlo", "Skládání na míru"], testid: "tier-premium" },
    { name: "Expres 24h", price: 80, sub: "+20 Kč/kg za rychlost", features: ["Doručení do 24 hodin", "Prioritní zpracování", "Standard nebo Premium"], testid: "tier-express-24" },
    { name: "Same-day", price: 100, sub: "+40 Kč/kg za stejný den", features: ["Vyzvedneme dopoledne, doručíme večer", "Pouze pro objednávky do 10:00", "Standard nebo Premium"], testid: "tier-same-day" },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="container-page py-16">
        <div className="tiny-label mb-3">Ceník</div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900 max-w-2xl">
          Platíte podle kilogramů. <span className="text-sky-600">Žádné překvapení.</span>
        </h1>
        <p className="mt-4 text-slate-600 max-w-xl">Naše ceny zahrnují vyzvednutí, praní, složení a doručení. Doprava je obvykle zdarma.</p>

        <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {tiers.map((t) => (
            <Card key={t.name} className={`p-7 relative ${t.featured ? "ring-2 ring-sky-500 border-sky-500" : ""}`} data-testid={t.testid}>
              {t.featured && <div className="absolute -top-3 left-7 px-3 py-0.5 bg-amber-400 text-amber-950 text-xs font-bold rounded-full">Nejoblíbenější</div>}
              <h3 className="font-display text-xl font-bold text-slate-900">{t.name}</h3>
              <div className="mt-3 flex items-baseline gap-1">
                <span className="font-display text-4xl font-extrabold text-slate-900">{t.price}</span>
                <span className="text-sm text-slate-500">Kč / kg</span>
              </div>
              <div className="text-sm text-slate-600">{t.sub}</div>
              <ul className="mt-5 space-y-2 text-sm text-slate-700">
                {t.features.map((f) => (
                  <li key={f} className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-sky-600 mt-0.5" /> {f}</li>
                ))}
              </ul>
              <Link to="/registrace?role=customer" className="mt-6 inline-flex w-full justify-center py-2.5 rounded-full bg-slate-900 text-white text-sm font-semibold hover:bg-slate-800">Objednat</Link>
            </Card>
          ))}
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6 max-w-4xl">
          <Card className="p-6 bg-sky-50 border-sky-200">
            <h3 className="font-display text-lg font-bold">Doprava zdarma</h3>
            <ul className="mt-3 space-y-1.5 text-sm text-sky-900">
              <li>• Vyzvednutí i doručení v ceně</li>
              <li>• Žádné skryté poplatky</li>
              <li>• Možnost dary na praní pro seniory</li>
            </ul>
          </Card>
          <Card className="p-6">
            <h3 className="font-display text-lg font-bold">Věrnostní body</h3>
            <p className="text-sm text-slate-600 mt-2">Za každou dokončenou objednávku získáte body. 1 bod = 1 Kč slevy na příští praní.</p>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PricingPage;
